import { replaceColluderRestrictions } from 'reducers/colluderRestrictions';
import { normalizeColluderRestrictions } from 'types/colluder';

type ReplaceAction = ReturnType<typeof replaceColluderRestrictions>;

/**
 * Normalise a decoded `gotColluderRestrictions` payload into the dispatchable
 * replace action. Each push is the full current restriction set (not a diff),
 * so this always replaces marker state wholesale. Factored out of the socket
 * hook so it can be unit-tested without a socket.
 *
 * Accepted shapes:
 *   - `{ restrictedCash, restrictedSng, restrictedMtt }` ← canonical push
 *   - `{ response: { ... } }`                            ← enveloped variant
 * Missing scopes normalise to empty arrays (clears that scope's markers).
 */
export const buildColluderRestrictionsAction = (decoded: unknown): ReplaceAction =>
  replaceColluderRestrictions(normalizeColluderRestrictions(decoded));
